export { default as PopularMobile } from './PopularMobile';



// WEBPACK FOOTER //
// ./src/containers/HomePage/PopularCategories/PopularMobile/index.ts